import React from 'react';
import Field from 'components/Form/Field';
import NotApplicable from 'components/Form/NotApplicable';
import ValidationElement, { ValidationElementProps } from 'components/Form/ValidationElement/ValidationElement';
import { i18n } from 'config/locales';
import { RelativeAffiliationModel } from 'forms/sections/relationships/relatives/relativeAffiliation';
import { CommonOnUpdate, CommonOnError } from 'types/props';
import Textarea from 'components/Form/Textarea';

interface Props extends Partial<RelativeAffiliationModel>, ValidationElementProps {
  required: boolean
  onUpdate: CommonOnUpdate
  onError: CommonOnError
  scrollIntoView: boolean
  attribute: string
}

export default class RelativeAffiliation extends ValidationElement<Props> {
  update = (queue: Partial<RelativeAffiliationModel>) => {
    this.props.onUpdate({ // eslint-disable-line @typescript-eslint/no-unsafe-call
      Explanation: this.props.Explanation,
      ExplanationNotApplicable: this.props.ExplanationNotApplicable,
      ...queue,
    });
  };

  updateExplanation = (values: RelativeAffiliationModel['Explanation']) => {
    this.update({
      Explanation: values,
    });
  };

  updateExplanationNotApplicable = (values: RelativeAffiliationModel['ExplanationNotApplicable']) => {
    this.update({
      ExplanationNotApplicable: values,
    });
  };

  render() {
    const attribute = `${this.props.attribute}.items[${this.props.$index}].Item`;
    return (
      <Field
        title={i18n.t('relationships.pvq.relatives.heading.employer.relationship')}
        scrollIntoView={this.props.scrollIntoView}
        attribute={`${attribute}.Explanation`}
      >
        <NotApplicable
          name="ExplanationNotApplicable"
          {...this.props.ExplanationNotApplicable}
          label={i18n.t('relationships.relatives.label.idk')}
          or={i18n.t('relationships.relatives.para.or')}
          onUpdate={this.updateExplanationNotApplicable}
          attribute="ExplanationNotApplicable"
        >
          <Textarea
            attribute={`${attribute}.Explanation`}
            name="Explanation"
            className="Explanation"
            {...this.props.Explanation}
            disabled={!this.props.ExplanationNotApplicable?.applicable}
            onError={this.props.onError}
            onUpdate={this.updateExplanation}
            required={this.props.required}
          />
        </NotApplicable>
      </Field>
    );
  }
}
RelativeAffiliation.defaultProps = {
  Explanation: {},
  ExplanationNotApplicable: { applicable: true },
  onUpdate: (queue) => { },
  onError: (value, arr) => arr,
};
